export default "__VITE_ASSET__D6p8UmVF__"